import { FC } from 'react'

interface InactivityWarningModalProps {
  onExtendSession: () => void
  onClose: () => void
}

export const InactivityWarningModal: FC<InactivityWarningModalProps> = ({ onExtendSession, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Session Timeout Warning
        </h2>
        <p className="text-gray-600 mb-6">
          Your session will expire in 5 minutes due to inactivity. Would you like to stay signed in?
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium"
          >
            Sign out now
          </button>
          <button
            onClick={() => {
              onExtendSession()
              onClose()
            }}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium"
          >
            Stay signed in
          </button>
        </div>
      </div>
    </div>
  )
}
